<script setup lang="ts">
import { useEnqueteEditPageQuery } from './EnqueteEditPage.generated'
import { useRoute } from 'vue-router'
import EnqueteEditPageContent from './EnqueteEditPageContent.vue'
import { ref } from 'vue'

const route = useRoute('EnqueteEditPage')

const enqueteGUID = route.params.enqueteGUID

// 一度更新したあと、フォームを再描画するためのキー
// これにより、保存済みの値はページを移動することなく保存済みとして描画され直す
const updateKey = ref<number>(new Date().getTime())

const pageQuery = useEnqueteEditPageQuery(
  {
    guid: enqueteGUID,
  },
  {
    fetchPolicy: 'no-cache',
  }
)

const handleUpdated = async () => {
  await pageQuery.refetch()
  updateKey.value = new Date().getTime()
}
</script>

<template>
  <section :class="$style.wrapper">
    <div :class="$style.container">
      <EnqueteEditPageContent
        v-if="pageQuery.result.value"
        :key="updateKey"
        :payload="pageQuery.result.value.enquete"
        :user-variable-definitions="
          pageQuery.result.value.userVariableDefinitions
        "
        @updated="handleUpdated"
      />
    </div>
  </section>
</template>

<style module lang="scss">
.wrapper {
  margin: 0 auto;
  width: 860px;
}
</style>
